module.exports = __webpack_public_path__ + "static/media/twelveth_miller_house1.e8629f64.jpg";